import { Entity } from 'ag-common-lib/public-api';
import { ReportIds } from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import {
  REPORTS_VIEWER_COMPARISON_ROUTE_PATH,
  REPORTS_VIEWER_PRODUCTION_HISTORY_ROUTE_PATH,
} from 'ag-common-svc/lib/modules/reports-viewer';

export const REPORTS_VIEWER_PERMISSIONS = [
  Entity.reportsViewerMgaSubmitted,
  Entity.reportsViewerMgaPaid,
  Entity.reportsViewerPersonalSubmitted,
  Entity.reportsViewerPersonalPaid,
  Entity.reportsViewerRmdSubmitted,
  Entity.reportsViewerRmdPaid,
  Entity.reportsViewerComparison,
  Entity.reportsViewerProductionHistory,
];

export const REPORTS_VIEWER_ROUTE_PERMISSION: Readonly<Record<string, Entity>> = {
  [ReportIds.mgaSubmit.replace(/_/g, '-')]: Entity.reportsViewerMgaSubmitted,
  [ReportIds.mgaPaid.replace(/_/g, '-')]: Entity.reportsViewerMgaPaid,
  [ReportIds.personalSubmit.replace(/_/g, '-')]: Entity.reportsViewerPersonalSubmitted,
  [ReportIds.personalPaid.replace(/_/g, '-')]: Entity.reportsViewerPersonalPaid,
  [ReportIds.rmdSubmit.replace(/_/g, '-')]: Entity.reportsViewerRmdSubmitted,
  [ReportIds.rmdPaid.replace(/_/g, '-')]: Entity.reportsViewerRmdPaid,
  [REPORTS_VIEWER_COMPARISON_ROUTE_PATH]: Entity.reportsViewerComparison,
  [REPORTS_VIEWER_PRODUCTION_HISTORY_ROUTE_PATH]: Entity.reportsViewerProductionHistory,
};
